import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Dashboard from './pages/Dashboard';
import OrganizationLanding from './pages/OrganizationLanding';
import OrganizationDashboard from './pages/OrganizationDashboard';
import Transactions from './pages/Transactions';
import Reconcile from './pages/Reconcile';
import Documents from './pages/Documents';
import Accounts from './pages/Accounts';
import AccountTransactions from './pages/AccountTransactions';
import Payees from './pages/Payees';
import Classes from './pages/Classes';
import Reports from './pages/Reports';
import Login from './pages/Login';
import UserManagement from './pages/UserManagement';
import ProjectManagement from './pages/ProjectManagement';
import Rules from './pages/Rules';
import AuditLog from './pages/AuditLog';
import AdminPortal from './pages/AdminPortal';
import SharedReportView from './pages/public/SharedReportView';
import { AuthProvider } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';
import PrivateRoute from './components/routing/PrivateRoute';
import './App.css';

const App = () => {
  return (
    <AuthProvider>
      <ProjectProvider>
        <Router>
          <Switch>
            <Route exact path="/shared/report/:token" component={SharedReportView} />
            <Route render={() => (
              <div className="app-container">
                <Navbar />
                <div className="main-content">
                  <Switch>
                    <Route exact path="/login" component={Login} />
                    <PrivateRoute exact path="/" component={OrganizationLanding} />
                    <PrivateRoute exact path="/orgs" component={OrganizationLanding} />
                    <PrivateRoute exact path="/org/:orgId/dashboard" component={OrganizationDashboard} />
                    <PrivateRoute exact path="/welcome" component={Dashboard} />
                    <PrivateRoute exact path="/transactions" component={Transactions} />
                    <PrivateRoute exact path="/reconcile" component={Reconcile} />
                    <PrivateRoute exact path="/documents" component={Documents} />
                    <PrivateRoute exact path="/accounts" component={Accounts} />
                    <PrivateRoute exact path="/accounts/:accountId/transactions" component={AccountTransactions} />
                    <PrivateRoute exact path="/payees" component={Payees} />
                    <PrivateRoute exact path="/classes" component={Classes} />
                    <PrivateRoute exact path="/reports" component={Reports} />
                    <PrivateRoute exact path="/rules" component={Rules} />
                    <PrivateRoute exact path="/users" component={UserManagement} />
                    <PrivateRoute exact path="/companies" component={ProjectManagement} />
                    <PrivateRoute exact path="/audit" component={AuditLog} />
                    <PrivateRoute exact path="/admin" component={AdminPortal} />
                  </Switch>
                </div>
              </div>
            )} />
          </Switch>
        </Router>
      </ProjectProvider>
    </AuthProvider>
  );
};

export default App;
